import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import femaleSrc from './female.png';
import maleSrc from './male.png';
import { Typography } from '@material-ui/core';

const styled = withStyles(theme => {
  return {
    container: {
      position: 'relative',
      display: 'flex',
    },
    photo: {},
    inactiveLabel: {
      position: 'absolute',
      top: 0,
      left: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.35)',
      color: '#fff',
      padding: '10px 20px',
    }
  };
});

export const getSrc = (user, index) => {
  if (Array.isArray(user.photos) && user.photos[index]) {
    let filename = user.photos[index].images[0].filename;
    if (user.photos[index].images.length > 1) {
      filename = user.photos[index].images[1].filename;
    } else {
      filename = user.photos[index].images[0].filename;
    }
    if (filename.indexOf('http') === -1) {
      return `${process.env.REACT_APP_CDN_HOST}/photos/${user._id}/${
        user.photos[index]._id
      }/${filename}`;
    } else {
      return filename;
    }
  } else {
    if (user.gender === 'male') {
      return maleSrc;
    } else {
      return femaleSrc;
    }
  }
};

const UserPhoto = ({ classes, user, photo, className, ...rest }) => {
  return (
    <div className={classes.container}>
      <img
        className={classnames(classes.photo, className)}
        alt={`${user.firstName} ${user.lastName}`}
        src={getSrc(user, photo)}
        {...rest}
      />
      {user.photos[photo] && user.photos[photo].status !== 'active' ? (
        <Typography className={classes.inactiveLabel}>{user.photos[photo].status}</Typography>
      ) : (
        <div />
      )}
    </div>
  );
};

export default styled(UserPhoto);
